import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    flex: 2,
    display: 'flex',
    flexDirection: 'column'
  },
  chat: {
    position: 'relative',
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden auto',
    height: ({ chatboxHeight }) =>
      `calc(100svh - calc(${chatboxHeight}px + 90px + 90px + 45px))`,

    '&::-webkit-scrollbar': {
      width: 8
    },

    '&::-webkit-scrollbar-track': {
      backgroundColor: '#E5E5E5'
    },

    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.primary.main,
      borderRadius: 0
    },
    [theme.breakpoints.down('md')]: {
      padding: '0px 14px',
      overflowY: 'overlay',
      height: ({ chatboxHeight }) =>
        `calc(100svh - calc(${chatboxHeight}px + 90px + 90px + 5px))`
    }
  },
  chatLine: {
    borderLeft: '1px solid lightgrey',
    height: '100%',
    position: 'absolute',
    left: 16,
    top: '0',
    zIndex: 2,
    [theme.breakpoints.down('md')]: {
      display: 'none'
    }
  },
  typing: {
    color: '#888888'
  },
  contentArea: {
    flex: 1,
    position: 'relative',
    backgroundColor: '#E5E5E5'
  }
}))

export default useStyles
